import { useParams } from '@tanstack/react-router';
import { ProductForm } from './components/ProductForm';

export function ProductFormPage() {
  const { productId } = useParams({ from: '/app/inventory/products/$productId' });
  const isNew = productId === 'new';

  return (
    <ProductForm 
      productId={isNew ? undefined : productId} 
      isNew={isNew}
    />
  );
}
